import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import InsuranceClaimsAnalytics from '@/components/insurance-sub/InsuranceClaimsAnalytics';
import InsuranceClaimsRecords from '@/components/insurance-sub/InsuranceClaimsRecords';
import { AlertTriangle } from 'lucide-react';

export default function InsuranceClaims() {
    return (
        <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
            <div className="mb-8">
                <div className="flex items-center gap-3 mb-2">
                    <AlertTriangle className="h-8 w-8" />
                    <h1 className="text-4xl font-semibold tracking-tight">Insurance Claims</h1>
                </div>
                <p className="text-muted-foreground">Insurance claim records.</p>
            </div>

            <Tabs defaultValue="analytics" className="space-y-6">
                <TabsList>
                    <TabsTrigger value="analytics">Analytics</TabsTrigger>
                    <TabsTrigger value="records">Records</TabsTrigger>
                </TabsList>

                <TabsContent value="analytics">
                    <InsuranceClaimsAnalytics />
                </TabsContent>

                <TabsContent value="records">
                    <InsuranceClaimsRecords />
                </TabsContent>
            </Tabs>
        </div>
    );
}
